import { useQuery } from '@tanstack/react-query';

import { queryClient } from '../components/queryClient';
import { useFleet } from '../hooks/useFleet';
import { FleetService } from '../services';

export const useHealthConfig = () => {
  const fleet = useFleet();
  const queryKey = ['HealthConfig', fleet.id];

  const queryFn = () => FleetService.getHealthConfigFilters();

  return useQuery({
    queryKey,
    queryFn,
    enabled: !!fleet.id,
  });
};

export const refreshHealthConfig = (fleetId: number) => {
  const queryKey = ['HealthConfig', fleetId];
  queryClient.invalidateQueries(queryKey);
};
